import { CanByRole } from '@app/core/auth/authorization/components/CanByRole';
import { UserRole } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';
import { NavItem } from '../../../components/layout/sidenav/link/NavItem';
import { AdminIcon } from '../AdminIcon';

export function AdminLinks() {
  return (
    <CanByRole role={UserRole.CLIENT_ADMIN}>
      <NavItem to="/admin" icon={<AdminIcon />}>
        <FormattedMessage id="admin.title" defaultMessage="Administración" />
      </NavItem>
    </CanByRole>
  );
}
